<template>
  <div class="login-box">
    <div class="login-logo">
      <div class="logo-item">
      </div>
    </div>
    <div class="login-content">
      <div class="login-main">
        <div class="login-card-box">
          <div class="image-box">
            <img src="../../static/image/login/u3_state0.png"/>
          </div>
          <div class="info-box">
            <div class="login-info-box">
              <div class="title">日月澄管理平台</div>
              <div class="hidden-input">
                <input type="text" class="form-control">
                <input type="password" class="form-control">
              </div>
              <el-form ref="loginForm" label-position="top" :rules="rules" label-width="40px" :model="login" class="login-form">
                <el-form-item prop="userName">
                  <el-input size="large" class="login-input" v-model="login.userName" placeholder="请输入账号" @keyup.enter.native="doLogin" clearable>
                    <template  #prefix><i class="el-icon-user mr5"></i></template>
                  </el-input>
                </el-form-item>
                <el-form-item prop="password">
                  <el-input size="large" class="login-input" autocomplete="new-password" auto-complete="new-password" type="password" v-model="login.password" placeholder="请输入密码" @keyup.enter.native="doLogin">
                    <template #prefix="prepend"><i class="el-icon-lock mr5"></i></template>
                  </el-input>
                </el-form-item>
                <el-form-item prop="code">
                  <el-input  size="large" class="login-input" @keyup.enter.native="doLogin" v-model="login.code"  placeholder=" 验证码">
                    <template #append>
                      <img @click="loadVerifyCode()" id="verifyCode" style="cursor:pointer;width:80px;height:30px;" title="验证码" width="60" height="37" />
                    </template>
                  </el-input>
                </el-form-item>
                <el-form-item>
                  <el-button size="medium" style="width:100%" type="primary" @click="doLogin">登录</el-button>
                </el-form-item>
              </el-form>
              <form method="post" id="loginForm">
                <input type="hidden" name="userName" v-model="login.userName"/>
                <input type="password" v-show="false" name="password" v-model="login.password"/>
                <input type="hidden" name="code" v-model="login.code"/>
              </form>
              <div v-show="show">
                <button id="loginEle"> </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="u4"></div>
    <div class="u5"></div>
    <div class="u6"></div>
    <div class="footer-but">
<!--      Copyright © 2022 广州市启橙网络技术有限公司 版权所有 粤ICP备18028829号-1-->
    </div>
  </div>

</template>
<script>
  import '../../static/plugin/jquery.form'
  import '../../static/plugin/jquery.jcryption.3.1.0'

  export default {
    name: 'Login',
    data () {
      return {
        login: {
          userName: '',
          password: '',
          code:'',
          source:source
        },
        code:'',
        checked: true,
        show:false,
        rules: {
          userName: [
            { required: true, message: '请输入账号', trigger: 'blur' }
          ],
          password: [
            { required: true, message: '请输入密码', trigger: 'blur' }
          ],
          code: [
            { required: true, message: '请输入验证码', trigger: 'blur' }
          ]
        }
      }
    },
    mixins: [tableBase],
    methods: {
      doLogin () {
        this.$refs['loginForm'].validate((valid) => {
          if (valid) {
            this.submitForm()
          }
        })
      },
      submitForm: function () {
        $('#loginEle').trigger('click')
      },
      loadVerifyCode(){
        $("#verifyCode").attr("src", baseURL+"/api/mgr/login/getVerifyCode?random=" + Math.random());
      }
    },
    mounted () {
      $('#loginForm').attr('action', baseURL + '/api/mgr/business/login/doPasswordLogin');
      this.initJCryption("#loginForm","#loginEle",(result)=>{
        localStorage.removeItem("qc_super_token");
        localStorage.setItem("qc_token",result.data.token);
        localStorage.removeItem("index");
        this.$store.commit("addIndex","0");
        this.$router.push({path: '/index/main'});
      });
      this.loadVerifyCode();
    }
  }
</script>

<style lang="less" scoped>
  .login-box{
    width: 100vw;
    height: 100vh;
    position: relative;
    background-color: #3691ff;
    .login-content{
      position: absolute;
      left:0;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: 100;
      .login-main{
        margin: 0 auto;
        width: 1200px;
        height: 100vh;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .logo{
          width: 540px;
          height: 50px;
          margin-bottom: 30px;
        }
        .login-card-box{
          display: flex;
          justify-content: space-between;
          width: 100%;
          .image-box{
            margin-top: -40px;
          }
          .info-box{
            width: 400px;
            height: 400px;
            margin-top: 65px;
            border-radius: 5px;
            background: #FFFFFF;
            box-shadow: 0px 10px 59px 0px rgba(4,0,0,0.3);
            .login-info-box{
              display: flex;
              flex-direction: column;
              align-items: center;
              .title{
                margin-top: 40px;
                margin-bottom: 40px;
                font-size: 20px;
                font-weight: bold;
              }
            }
          }
        }
      }
    }

    .login-logo{
      position: absolute;
      width: 100%;
      .logo-item{
        padding: 30px 0px;
        margin: 0 auto;
        width: 1200px;
      }
    }
    .u4{
      position: absolute;
      width: 100%;
      background-image:url("../../static/image/login/u4_state0.png");
      background-position: center bottom;
      background-repeat: no-repeat;
      background-attachment: scroll;
      background-size: contain;
      background-origin: border-box;
      border: none;
      border-radius: 0px;
      box-shadow: none;
      z-index: 2;
      box-shadow: none;
      height: 100vh;
    }

    .u5{
      position: absolute;
      width: 100%;
      background-image:url("../../static/image/login/u5.svg");
      background-position: center bottom;
      background-repeat: no-repeat;
      background-attachment: scroll;
      background-size: contain;
      background-origin: border-box;
      border: none;
      height: 100px;
      margin-top: 30%;
    }

    .u6{
      position: absolute;
      width: 150px;
      background-image:url("../../static/image/login/u5.svg");
      background-position: center bottom;
      background-repeat: no-repeat;
      background-attachment: scroll;
      background-size: contain;
      background-origin: border-box;
      border: none;
      height: 150px;
      margin-top: 10%;
      margin-left: 10%;
    }
    .footer-but{
      width: 100%;
      padding: 10px;
      text-align: center;
      position: fixed;
      bottom: 0px;
      left: 0px;
      z-index: 9999;
      background: #ffffff;
    }
  }
</style>
